import { useState } from "react";
import { Gift, Tag, X } from "lucide-react";
import { formatPrice } from "@/lib/format";

// Código de desconto ou oferta no checkout: aplica-se a um código, mostra a mensagem da oferta e pede o campo extra, se o código tiver um.
export function CouponBox({ coupon, extra, onExtra, onApply, onRemove, error, busy, perBox = false }) {
  const [code, setCode] = useState("");
  if (coupon) {
    return (
      <div className="space-y-3 rounded-2xl bg-ivory p-4" data-testid="coupon-applied">
        <div className="flex items-start justify-between gap-3">
          <p className="flex items-start gap-2 text-sm font-semibold text-bordeaux">
            {coupon.kind === "gift" ? <Gift className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" /> : <Tag className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />}
            <span>Código {coupon.code}{coupon.discount_cents > 0 ? `: −${formatPrice(coupon.discount_cents / 100)}` : coupon.gift ? `: ${coupon.gift.name} de oferta` : ""}</span>
          </p>
          <button type="button" onClick={onRemove} data-testid="coupon-remove" aria-label="Retirar código" className="grid h-8 w-8 shrink-0 place-items-center rounded-full text-taupe hover:bg-rose-soft hover:text-bordeaux"><X className="h-4 w-4" /></button>
        </div>
        {coupon.message && <p className="text-sm leading-relaxed text-taupe-strong" data-testid="coupon-message">{coupon.message}</p>}
        {coupon.extra_field && perBox && <p className="text-sm text-taupe-strong" data-testid="coupon-per-box">Com caixas de oferta, há uma oferta por caixa, com o {coupon.extra_field.label.toLowerCase()} que indicares em cada uma.</p>}
        {coupon.extra_field && !perBox && (
          <div>
            <label htmlFor="coupon-extra" className="mb-1.5 block text-sm font-semibold text-ink">{coupon.extra_field.label}</label>
            <input id="coupon-extra" data-testid="coupon-extra-input" value={extra} maxLength={coupon.extra_field.max_length} onChange={(e) => onExtra(e.target.value)} required
              className="h-12 w-full rounded-xl border border-ink/20 bg-white px-4 text-base outline-none transition-[border-color] focus:border-bordeaux" />
          </div>
        )}
      </div>
    );
  }
  return (
    <div data-testid="coupon-box">
      <label htmlFor="coupon-code" className="mb-1.5 block text-sm font-semibold text-ink">Tens um código?</label>
      <div className="flex gap-2">
        <input id="coupon-code" data-testid="coupon-input" value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} maxLength={40} autoCapitalize="characters" autoComplete="off"
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); if (code.trim()) onApply(code); } }}
          className="h-12 min-w-0 flex-1 rounded-xl border border-ink/20 bg-white px-4 text-base uppercase outline-none transition-[border-color] focus:border-bordeaux" />
        <button type="button" data-testid="coupon-apply" disabled={busy || !code.trim()} onClick={() => onApply(code)} className="bb-btn-ghost min-h-[48px] shrink-0 px-5">{busy ? "..." : "Aplicar"}</button>
      </div>
      {error && <p role="alert" data-testid="coupon-error" className="mt-2 text-sm text-bordeaux">{error}</p>}
    </div>
  );
}
